import { makeEroadStyles } from "./makeEroadStyles";

const useStorybookGlobalStyles = makeEroadStyles((theme) => ({
  "@global": {
    html: {
      fontSize: 10, // to make `rem` units working as expected
    },
    "div#root": {
      fontFamily: theme.typography.fonts.primary,
      fontSize: theme.spacing(4),
      padding: theme.spacing(4),

      "& h1 + h3": {
        marginTop: -theme.spacing(4),
        marginBottom: theme.spacing(4),
      },
      "& p": {
        margin: `${theme.spacing(3)}px 0`,

        "&:first-child": {
          marginTop: 0,
        },
      },
      "& ul": {
        paddingLeft: theme.spacing(2),
        listStylePosition: "inside",
      },
      "& li ul": {
        paddingLeft: theme.spacing(4),
      },
      "& > div": {
        color: "inherit",
        fontSize: "inherit",
        padding: 0,
      },
    },
  },
}));

export { useStorybookGlobalStyles };
